import Cooperation from './Cooperation'
import Login from './Login'
// import Register from './Register'
import RegisterNew from './RegisterNew'
import BankId from './BankId'
import BankIdInfo from './BankIdInfo'
import InvestorForm from './InvestorForm'

export default function install(Vue) {
  Vue.component('auth-cooperation', Cooperation)
  Vue.component('auth-login', Login)
  // Vue.component('auth-register', Register)
  Vue.component('auth-register-new', RegisterNew)
  Vue.component('auth-bank-id', BankId)
  Vue.component('auth-bank-id-info', BankIdInfo)
  Vue.component('auth-investor-form', InvestorForm)
}
